import { FormacionesDictadasTab } from "../psychologist/tabs";

export const FormacionesDictadasPage = () => {
  return <FormacionesDictadasTab />;
};
